import React from 'react';
import LogoPath from '../assets/images/logo-welireg-white.svg';
import eaPath from '../assets/images/logo-ea-white.svg';
import merckPath from '../assets/images/logo-merck-white.svg';
import privacyChoicesImg from '../assets/images/yourprivacychoices.svg';

const footerCopy = {
  footerLogo: {
    img: LogoPath,
    alt: "WELIREG® (belzutifan) Logo",
  },
  footerUtilLinks: {
    patientSite: {
      copy: "Visit Patient Site",
      href: "https://www.welireg.com/",
      keys: ["vhl", "rcc", "ut", "mt"],
    },
    contactUs: {
      copy: "Contact Us",
      href: "/contact-us",
      keys: ["vhl", "rcc", "mt", "ut"],
    },
  },
  footerSiteLinks: {
    col1: [
      {
        href: "/advanced-renal-cell-carcinoma/",
        label: "Home for Advanced Clear Cell RCC",
        keys: ["ut", "mt"],
      },
      {
        href: "/von-hippel-lindau/what-is-von-hippel-lindau",
        label: "What is VHL Disease?",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/mechanism-of-action",
        label: "Mechanism of Action",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/efficacy",
        label: "Efficacy",
        keys: ["vhl"],
      },
      {
        label: "Mechanism of Action",
        href: "/advanced-renal-cell-carcinoma/mechanism-of-action",
        keys: ["rcc"],
      },
      {
        label: "Efficacy",
        href: "/advanced-renal-cell-carcinoma/efficacy",
        keys: ["rcc"],
      },
      {
        label: "Treatment Sequencing",
        href: "/advanced-renal-cell-carcinoma/treatment-sequencing-and-patient-profiles/",
        keys: ["rcc"],
      },
     
    ],
    col2: [
      {
        href: "/von-hippel-lindau/",
        label: <>Home for VHL Disease&#8211;Associated Tumors</>,
        keys: ["ut", "mt"],
      },
      {
        href: "/von-hippel-lindau/adverse-reaction-profile/",
        label: "Safety",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/guidelines",
        label: "Guidelines",
        keys: ["vhl"],
      },
      {
        href: '/von-hippel-lindau/patient-identification',
        label: 'Patient Identification',
        keys: ['vhl']
      },
      {
        label: "Safety",
        href: "/advanced-renal-cell-carcinoma/safety",
        keys: ["rcc"],
      },
     
      {
        label: "Guidelines",
        href: "/advanced-renal-cell-carcinoma/guidelines",
        keys: ["rcc"],
      },
    ],
    col3: [
      {
        href: "/von-hippel-lindau/dosing",
        label: "Dosing",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/resources",
        label: "Resources & Dispensing",
        keys: ["vhl"],
      },
      {
        label: "Dosing",
        href: "/advanced-renal-cell-carcinoma/dosing",
        keys: ["rcc"],
      },
      {
        label: "Resources & Dispensing",
        href: "/advanced-renal-cell-carcinoma/resources-and-access",
        keys: ["rcc"],
      },
    ],
  },
  subLinks: [
    {
      copy: "Privacy Policy",
      href: "https://www.msdprivacy.com/us/en/",
      keys: ["vhl", "rcc", "mt", "ut"],
    },
    {
      copy: "Terms of Use",
      href: "https://www.merck.com/terms-of-use/",
      keys: ["vhl", "rcc", "mt", "ut"],
    },
    {
      copy: "Site Map",
      href: "/site-map",
      target: "_self",
      keys: ["vhl", "rcc", "mt", "ut"],
    },
    {
      copy: "Cookie Preferences",
      class: "ot-sdk-show-settings",
      target: "_self",
      href: "javascript:void(0)",
      keys: ["vhl", "rcc", "mt", "ut"],
    },
    {
      copy: "Accessibility",
      href: "https://www.msdaccessibility.com/",
      keys: ["vhl", "rcc", "mt", "ut"],
    },
    {
      copy: 'Your Privacy Choices',
      href: 'https://dsr.msd.com/DSR/United_States/English/',
      keys: ['vhl', 'rcc', 'mt', 'ut'],
      image: privacyChoicesImg,
      alt:'Visit Your Privacy Choices',
    },
    {
      copy: 'Consumer Health Data Privacy Policy',
      href: 'https://www.msdprivacy.com/us/en/chd-policy/',
      keys: ['vhl', 'rcc', 'mt', 'ut']
    }
  ],
  footerBottom: {
    left: [
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-WRC-00366 06/25",
        keys: ["rcc"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-BEL-01688 11/25",
        keys: ["vhl"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-BEL-01508 06/25",
        keys: ["mt"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-BEL-01508 06/25",
        keys: ["ut"],
      },
    ],
    accessibility: {
      href: "https://www.essentialaccessibility.com/merck/?utm_source=merck-homepage&utm_medium=icon-large&utm_term=eachannel-page&utm_content=header&utm_campiagn=merck",
      img: eaPath,
      alt: "Level Access Company Logo",
    },
    merckLogo: {
      img: merckPath,
      alt: "Merck Logo",
    },
  },
};


export const multiBrandFooterCopy = {
  footerLogo: {
    img: LogoPath,
    alt: "WELIREG® (belzutifan) Logo",
  },
  footerUtilLinks: {
    patientSite: {
      copy: "Visit Patient Site",
      href: "https://www.welireg.com/",
      keys: ["vhl", "rcc", "ut", "mt", "arcc"],
    },
    contactUs: {
      copy: "Contact Us",
      href: "/contact-us/",
      keys: ["vhl", "rcc", "mt", "ut", "arcc"],
    },
  },
  footerSiteLinks: {
    col1: [
      {
        href: "/advanced-renal-cell-carcinoma/",
        label: "Home for Advanced Clear Cell RCC",
        keys: ["ut", "mt"],
      },
      {
        href: "/von-hippel-lindau/",
        label: "Home for VHL Disease–Associated Tumors",
        keys: ["ut", "mt"],
      },
      {
        href: "/von-hippel-lindau/what-is-von-hippel-lindau",
        label: "What is VHL Disease?",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/mechanism-of-action",
        label: "Mechanism of Action",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/efficacy",
        label: "Efficacy",
        keys: ["vhl"],
      },
      {
        label: "Mechanism of Action",
        href: "/advanced-renal-cell-carcinoma/mechanism-of-action",
        keys: ["rcc"],
      },
      {
        label: "Efficacy",
        href: "/advanced-renal-cell-carcinoma/efficacy",
        keys: ["rcc"],
      },
      {
        label: "Treatment Sequencing",
        href: "/advanced-renal-cell-carcinoma/treatment-sequencing-and-patient-profiles/",
        keys: ["rcc"],
      },
      {
        href: "/adjuvant-renal-cell-carcinoma/risk-of-recurrence/",
        label: "Risk of Recurrence",
        keys: ["arcc"],
      },
      {
        href: "/adjuvant-renal-cell-carcinoma/mechanisms-of-action/",
        label: "Mechanisms of Action",
        keys: ["arcc"],
      },
     
    ],
    col2: [
      {
        href: "/adjuvant-renal-cell-carcinoma/",
        label: "Home for Combination Adjuvant Treatment for Clear Cell RCC",
        keys: ["ut", "mt"],
      },
      {
        href: "/von-hippel-lindau/",
        label: <>Home for VHL Disease&#8211;Associated Tumors</>,
        keys: [""],
      },
      {
        href: "/von-hippel-lindau/adverse-reaction-profile/",
        label: "Safety",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/guidelines",
        label: "Guidelines",
        keys: ["vhl"],
      },
      {
        href: '/von-hippel-lindau/patient-identification',
        label: 'Patient Identification',
        keys: ['vhl']
      },
      {
        label: "Safety",
        href: "/advanced-renal-cell-carcinoma/safety",
        keys: ["rcc"],
      },
     
      {
        label: "Guidelines",
        href: "/advanced-renal-cell-carcinoma/guidelines",
        keys: ["rcc"],
      },
       {
        href: "/adjuvant-renal-cell-carcinoma/efficacy-and-safety/",
        label: "Efficacy & Safety",
        keys: ["arcc"],
      },
      {
        href: "/adjuvant-renal-cell-carcinoma/dosing-and-administration/",
        label: "Dosing & Administration",
        keys: ["arcc"],
      },
    ],
    col3: [
      {
        href: "/von-hippel-lindau/dosing",
        label: "Dosing",
        keys: ["vhl"],
      },
      {
        href: "/von-hippel-lindau/resources",
        label: "Resources & Dispensing",
        keys: ["vhl"],
      },
      {
        label: "Dosing",
        href: "/advanced-renal-cell-carcinoma/dosing",
        keys: ["rcc"],
      },
      {
        label: "Resources & Dispensing",
        href: "/advanced-renal-cell-carcinoma/resources-and-access",
        keys: ["rcc"],
      },
      {
        href: "/adjuvant-renal-cell-carcinoma/resources-and-ordering/",
        label: "Resources & Ordering",
        keys: ["arcc"],
      },
      
    ],
  },
  subLinks: [
    {
      copy: "Privacy Policy",
      href: "https://www.msdprivacy.com/us/en/",
      keys: ["vhl", "rcc", "mt", "ut", "arcc"],
    },
    {
      copy: "Terms of Use",
      href: "https://www.merck.com/terms-of-use/",
      keys: ["vhl", "rcc", "mt", "ut", "arcc"],
    },
    {
      copy: "Site Map",
      href: "/site-map/",
      target: "_self",
      keys: ["vhl", "rcc", "mt", "ut", "arcc"],
    },
    {
      copy: "Cookie Preferences",
      class: "ot-sdk-show-settings",
      target: "_self",
      href: "javascript:void(0)",
      keys: ["vhl", "rcc", "mt", "ut", "arcc"],
    },
    {
      copy: "Accessibility",
      href: "https://www.msdaccessibility.com/",
      keys: ["vhl", "rcc", "mt", "ut", "arcc"],
    },
    {
      copy: 'Your Privacy Choices',
      href: 'https://dsr.msd.com/DSR/United_States/English/',
      keys: ['vhl', 'rcc', 'mt', 'ut', "arcc"],
      image: privacyChoicesImg,
      class: "privacy-choice",
      alt:'Visit Your Privacy Choices',
    },
    {
      copy: 'Consumer Health Data Privacy Policy',
      href: 'https://www.msdprivacy.com/us/en/chd-policy/',
      keys: ['vhl', 'rcc', 'mt', 'ut', "arcc"]
    }
  ],
  footerBottom: {
    left: [
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-WRC-00366 06/25",
        keys: ["rcc"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-BEL-01688 11/25",
        keys: ["vhl"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2026 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-BEL-01677 07/26",
        keys: ["mt"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2026 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-WRC-00553 08/26",
        keys: ["arcc"],
      },
      {
        copy: "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.",
        subcopy: "US-BEL-01677 08/26",
        keys: ["ut"],
      },
    ],
    accessibility: {
      href: "https://www.essentialaccessibility.com/merck/?utm_source=merck-homepage&utm_medium=icon-large&utm_term=eachannel-page&utm_content=header&utm_campiagn=merck",
      img: eaPath,
      alt: "Level Access Company Logo",
    },
    merckLogo: {
      img: merckPath,
      alt: "Merck Logo",
    },
  },
};



export default footerCopy;